module.exports = sha256;